import apiHelper from '@/services/helper'
import apiHelperFinance from '@/services/helperFinance'

const getListExportExcel = async (param) => {
    try {
        let url = '/admin/order/export'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getScgStatusExcelFull = async (param) => {
    try {
        let url = '/admin/order/export-scg-status-full'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getScgStatusExcelShort = async (param) => {
    try {
        let url = '/admin/order/export-scg-status-short'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOrderByOrderNumbers = async (param) => {
    try {
        let url = '/admin/order/get-order-numbers'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOrderLogByOrderNumber = async (param) => {
    try {
        let url = '/admin/order/get-log'
        return (await apiHelperFinance.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateOrderCsInfo = async (param) => {
    try {
        let url = '/admin/order/update-customer-service'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getAllProductShopId = async (param) => {
    try {
        let url = '/admin/product/export'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateOrderAddress = async (param) => {
    try {
        let url = '/admin/order/update-address'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const createShipment = async (param) => {
    try {
        let url = '/admin/shipment/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateShipment = async (param) => {
    try {
        let url = '/admin/shipment/update'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const countExportOrder = async (param) => {
    try {
        let url = '/admin/order/count-export'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const ExportOrder = async (param) => {
    try {
        let url = '/admin/order/export-all'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const checkZipcode = async (param) => {
    try {
        let url = '/admin/courier/provider/get-zipcode-time?' + param
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchProvince = async (param) => {
    try {
        let url = '/admin/province/search'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchDistrict = async (param) => {
    try {
        let url = '/admin/district/search'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchSubDistrict = async (param) => {
    try {
        let url = '/admin/sub-district/search'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchZipcode = async (param) => {
    try {
        let url = '/admin/zipcode/search'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateZipcode = async (param) => {
    try {
        let url = '/admin/zipcode/update'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateProvince = async (param) => {
    try {
        let url = '/admin/province/update'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateDistrict = async (param) => {
    try {
        let url = '/admin/district/update'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateSubDistrict = async (param) => {
    try {
        let url = '/admin/sub-district/update'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createZipcode = async (param) => {
    try {
        let url = '/admin/zipcode/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createDistrict = async (param) => {
    try {
        let url = '/admin/district/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const createSubDistrict = async (param) => {
    try {
        let url = '/admin/sub-district/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const exportOrderStatusArray = async (param) => {
    try {
        let url = '/admin/order/export-status-array'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const updateDeliveryCost = async (param) => {
    try {
        let url = '/admin/order/update-delivery-cost'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const verifyAddress = async (param, cancelToken = null) => {
    try {
        let url = '/admin/order/verify-address'
        return (await apiHelper.postWithFirebaseToken(url, param, true, cancelToken)).data
    } catch (error) {
        throw new Error(error)
    }
}

const changeStatusLogOrder = async (param) => {
    try {
        let url = '/admin/order/change-to-complete'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const checkCovidAddress = async (param) => {
    try {
        let url = '/courier/check-covid-area'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const deleteOrderLogOrder = async (param) => {
    try {
        let url = '/admin/order/delete'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchListZipcode = async (param) => {
    try {
        let url = '/admin/zipcode/search-list'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const kpCreateOrder = async (param) => {
    try {
        let url = '/admin/order/kp-create-order'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getListExportExcel,
    getScgStatusExcelFull,
    getScgStatusExcelShort,
    getOrderByOrderNumbers,
    getOrderLogByOrderNumber,
    updateOrderCsInfo,
    getAllProductShopId,
    updateOrderAddress,
    createShipment,
    countExportOrder,
    ExportOrder,
    checkZipcode,
    searchProvince,
    searchDistrict,
    searchSubDistrict,
    searchZipcode,
    updateZipcode,
    updateProvince,
    updateDistrict,
    updateSubDistrict,
    createZipcode,
    createDistrict,
    createSubDistrict,
    exportOrderStatusArray,
    updateDeliveryCost,
    verifyAddress,
    changeStatusLogOrder,
    checkCovidAddress,
    deleteOrderLogOrder,
    searchListZipcode,
    updateShipment,
    kpCreateOrder
}
